<template>
  <div class="nav-bar-box" @click.stop>
    <div class="nav-banner">
      <ul class="item-box flex align-items-center">
        <li
          class="flex align-items-center"
          :class="isShow(item) ? 'show-bg color-red' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="jumpPage(item,1)"
        >
          <div v-if="item.type === 'dropDown'" class="flex align-items-center">
            <div>{{ item.name }}</div>
            <a-icon
              style="margin-top: 5px; margin-left: 5px"
              v-if="item.isShowDropDown && item.type === 'dropDown'"
              type="caret-up"
            />
            <a-icon
              style="margin-top: 5px; margin-left: 5px"
              v-if="item.isShowDropDown === false && item.type === 'dropDown'"
              type="caret-down"
            />
          </div>
          <div v-else>
            <div>{{ item.name }}</div>
          </div>
          <div id="item" class="drop-down-box" v-if="item.isShowDropDown && item.type === 'dropDown'">
            <ul>
              <li v-for="(item, index) in navList[1].dropDownList" :key="index" @click.stop="jumpPage(item,2)"> {{ item.title }} </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    navList: {
      type: Array,
      default: () => [
        { name: "首页", routeName: "Homes", path: "/homes" },
        {
          name: "系统设置",
          dropDownList: [
            {
              title: "用户管理",
              routeName: "systemSettingsUserManagement",
            },
            {
              title: "申报设置",
              routeName: "systemSettingsSetUp",
            },
            {
              title: "评审设置",
              routeName: "systemSettingsReviewSetUp",
            }, 
                                              ],
          isShowDropDown: false,
          type: "dropDown",
        },
        {
          name: "承诺书",
          routeName: "personalCenterLetterCommitment",
          path: "/personalCenter/letterCommitment",
        },
        {
          name: "报名信息",
          routeName: "personalCenterRegistrationInformation",
          path: "/personalCenter/registrationInformation",
        },
        {
          name: "资料上传",
          routeName: "personalCenterDataUpload",
          path: "/personalCenter/dataUpload",
        },
        { name: "申报指南", routeName: "Guide", path: "/home/guide" },
      ],
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  methods: {
    isShow(item) {
      if (
        this.$route.name === item.routeName ||
        this.$route.name.indexOf(item.routeName) !== -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    jumpPage(item,type) {
      if (item.type !== "dropDown") {
        if(type === 2){
          this.navList[1].isShowDropDown = false
        }
        this.$emit("jumpPage", item);
      } else {
       this.$emit("isShowDropDown");
        item.isShowDropDown = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.nav-bar-box {
  height: 100%;
}

.nav-banner {
  width: 100%;
  margin: 0 auto;
}
.item-box {
  height: 46px;
  > :nth-child(2) {
    position: relative;
    display: inline-block;
    line-height: 43px;
  }
}
.item-box > li {
  height: 100%;
  padding: 0 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  cursor: pointer;
}
.show-bg {
  background: #BFD6FF;
}
.color-red {
  color: #2155B5;
}
.drop-down-box {
  position: absolute !important;
  top: 46px;
  left: 0px;
  width: 100%;
  height: auto;
  z-index: 99;
  background: #fff;
  border: 1px solid #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.18);
  :last-child {
    border: none;
  }
  ul li {
    margin: 0 20px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }
  ul li:hover {
    color: #2155B5;
  }
}
</style>
